export const MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
] as const;

export const LANGUAGES = [
  'English',
  'French',
  'Spanish',
  'Arabic',
  'Mandarin',
  'Cantonese',
  'Tagalog',
  'Portuguese',
  'German',
  'Italian',
  'Vietnamese',
  'Korean',
  'Polish',
  'Urdu',
  'Hindi',
  'Other',
] as const;

export const HEAR_ABOUT_OPTIONS = [
  'Friend',
  'Public Health Nurse',
  'Doctor',
  'Social Media',
  'Hospital',
  'Flyer',
  'Online',
  'Talk with Me',
  'CAFI/MAGMA',
  'Referral',
  'Other',
] as const;

export const MAX_ADULTS = 5;
export const MAX_CHILDREN = 5;

export const generateAdultYears = (currentYear = new Date().getFullYear()): number[] => {
  return Array.from({ length: 100 }, (_, i) => currentYear - 18 - i);
};

export const generateChildYears = (currentYear = new Date().getFullYear()): number[] => {
  return Array.from({ length: 19 }, (_, i) => currentYear - i);
};

export const generatePregnancyYears = (currentYear = new Date().getFullYear()): number[] => {
  return [currentYear, currentYear + 1];
};
